module.exports = __webpack_public_path__ + "static/media/freshpaint2.5d995fe2.jpg";